import React, { useEffect, useState, useRef } from "react";
import { PropTypes } from "prop-types";
import reactWrapper from "@harbor/elements/utils/react/wrapper";

//utils
import { BASE_TENANT_URL } from "../../../apis/apiConstants";

import { useI18n } from "../../../i18n/useI18n";
import apiService from "../../../config/api-config";

const [
    HbrIcon,
    HbrMenuItem,
    HbrMenu,
    HbrMenuLabel,
    HbrNavItem
] = reactWrapper([
    "hbr-icon",
    "hbr-menu-item",
    "hbr-menu",
    "hbr-menu-label",
    "hbr-nav-item",

]);

const MultiTenantMenu = ({ tenantId }) => {
    const { tGenerics } = useI18n('generics');
    const [listTenants, setListTenants] = useState([]);
    const [selectedName, setSelectedName] = useState("");
    const dataRef = useRef({
        error: null,
        isLoading: true
    })

    const getTenant = async () => {
        const result = await apiService.getTenantInfo();
        const selectedTenant = result.errorObject instanceof Object || !result.data || !result.data.data ?
            null :
            result.data.data.filter((tenantObject) => tenantObject.tenantId === tenantId);

        if (Array.isArray(selectedTenant) && selectedTenant.length > 0) {
            // selectedTenant is an array and it has at least one element
            setSelectedName(selectedTenant[0].name);
            setListTenants(result.data.data);
        } else {
            setListTenants([]);
            dataRef.current.error = true;
        }
    }

    useEffect(() => {
        getTenant();
        dataRef.current.isLoading = false;
    }, [])

    const redirectToVMange = (event) => {
        if (event?.currentTarget?.value && event.currentTarget.value !== "provider") {
            window.location.href = `/#/${event.currentTarget.value}${BASE_TENANT_URL}/overview`
        } else {
            window.location.href = `/#${BASE_TENANT_URL}/overview`
        }
    }

    if (dataRef.current.error || dataRef.current.isLoading)
        return (<></>)
    else
        return (
            <HbrNavItem switcher collapsed value="tenant-switcher" className="nav-item-section">
                <HbrIcon slot="prefix" name="nav-network-switcher" size="22px" />
                <div slot="content-header">{tGenerics('megaMenuOperatedLabel')}</div>
                <div slot="content">{selectedName}</div>
                <div slot="drawerHeader">{tGenerics('selectTenantLabel')}</div>
                <div slot="menu" className="sub-menu">
                    <HbrMenu shellNav className="menu-item">
                        <HbrMenuItem shellNav value="provider" onClick={(event) => redirectToVMange(event)}>
                            {tGenerics('multiTenantProvider')}
                        </HbrMenuItem>
                        <HbrMenuLabel shellNav>{tGenerics('multiTenant')}</HbrMenuLabel>
                        {listTenants.map((tenant, key) => (
                            <HbrMenuItem className="hbr-menu-item-group" checked={selectedName === tenant.name} key={key} value={tenant.tenantId} onClick={(event) => redirectToVMange(event)}>
                                {tenant.name}
                            </HbrMenuItem>
                        ))}
                    </HbrMenu>
                </div>
            </HbrNavItem>
        )
}

MultiTenantMenu.propTypes = {
    title: PropTypes.string,
    globalFilter: PropTypes.string,
    tenantId: PropTypes.string,
};

export default MultiTenantMenu;
